import { createAction } from 'redux-actions';

export const NAMES = {
  UPDATE_VIDEO_LIVE_STATUS: 'CLIENT.VIDEOS.UPDATE_LIVE_STATUS',
};

export const updateLiveStatus = createAction(NAMES.UPDATE_VIDEO_LIVE_STATUS);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/videos.js